import React, { useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import { useQuery, gql } from '@apollo/client';
import OnboardingView from '../components/OnboardingView';
import i18n, { LANGUAGES, storedLanguage } from '../i18n';

export const HOME_ONBOARDING_QUERY = gql`
  query HomeOnboarding {
    viewer {
      id
      onboarding {
        locations
        onboarding
        onboardingDate
        onboardingMeetingUrl
      }
    }
  }
`;

// Separate from HomeOnboarding so an API without Viewer.lang only costs the translation, not the checklist.
const VIEWER_LANG_QUERY = gql`
  query ViewerLang {
    viewer {
      id
      lang
    }
  }
`;

// CSMs update the checklist by hand from Retool; re-checking keeps an open page current without a reload.
const POLL_INTERVAL_MS = 30 * 1000;

// Trial users still setting up see their checklist; everyone else goes to the videos.
const Home = () => {
  const { data, loading, error } = useQuery(HOME_ONBOARDING_QUERY, {
    fetchPolicy: 'network-only',
    pollInterval: POLL_INTERVAL_MS,
  });
  const { data: langData, loading: langLoading } = useQuery(VIEWER_LANG_QUERY);
  const companyLang = langData?.viewer?.lang;

  // Start in the company's language, unless this browser already picked one with the switcher.
  useEffect(() => {
    if (companyLang && LANGUAGES.includes(companyLang) && !storedLanguage()) {
      i18n.changeLanguage(companyLang);
    }
  }, [companyLang]);

  if (loading || langLoading) {
    return <div />;
  }

  // Fail open: on any error (e.g. the API doesn't have viewer.onboarding yet) keep today's behaviour.
  const onboarding = data?.viewer?.onboarding;
  if (error || !onboarding) {
    return <Redirect to="/orders" />;
  }

  return <OnboardingView {...onboarding} />;
};

export default Home;
